import { EnrollmentContextResponseDto } from "theSource/queries/useEnrollmentContextQuery/types";
import { isLifeEventNotOpen } from 'features/HomePage/components/ReportLifeEventBanner/utils/utils';

export const shouldShowLifeEvent = (
  enrollmentContext: EnrollmentContextResponseDto | undefined
): boolean => {
  return Boolean(enrollmentContext && isLifeEventNotOpen(enrollmentContext));
};